import { AgreementsDocumentVersionModel, AgreementsDocumentModel } from '.'
import { isUnknownObject } from '~/shared/utils/guards'
import { fillOwnProperties } from '~/shared/utils/helpers'
import { BaseModel } from '~/shared/model'

export default class AgreementsSignature extends BaseModel {
  id: string = ''
  email: string = ''
  phone: string = ''
  signingUrl: string = ''
  createdAt: string = ''
  document: AgreementsDocumentModel | null = null
  version: AgreementsDocumentVersionModel | null = null

  constructor(data: unknown) {
    super()
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data, ['document', 'version'])

      if (isUnknownObject(data.document)) {
        this.document = new AgreementsDocumentModel(data.document)
      }

      if (isUnknownObject(data.version)) {
        this.version = new AgreementsDocumentVersionModel(data.version)
      }
    }
  }
}
